import { supabaseClient, isSupabaseConfigured } from '../lib/supabase'

// Settings utility - reads from Supabase with localStorage cache
export interface AppSettings {
  companyName: string
  email: string
  phone: string
  address: string
  currency: string
  taxRate: string
  orderCutoffTime: string
  deliveryStartTime: string
  deliveryEndTime: string
  enableNotifications: boolean
  enableEmailAlerts: boolean
  autoAcceptOrders: boolean
  requireOrderConfirmation: boolean
}

const DEFAULT_SETTINGS: AppSettings = {
  companyName: 'Criket',
  email: 'admin@criket.com',
  phone: '809-555-1234',
  address: 'Santo Domingo, República Dominicana',
  currency: 'RD$',
  taxRate: '18',
  orderCutoffTime: '23:00',
  deliveryStartTime: '12:00',
  deliveryEndTime: '14:00',
  enableNotifications: true,
  enableEmailAlerts: true,
  autoAcceptOrders: false,
  requireOrderConfirmation: true,
}

// Synchronous getter - reads from localStorage cache (always up to date if loadSettingsFromSupabase ran)
export function getSettings(): AppSettings {
  const saved =
    localStorage.getItem('criket_general_settings') ||
    localStorage.getItem('criket_settings')
  if (saved) {
    try {
      return { ...DEFAULT_SETTINGS, ...JSON.parse(saved) }
    } catch {
      return DEFAULT_SETTINGS
    }
  }
  return DEFAULT_SETTINGS
}

// Async loader - fetches from Supabase and caches to localStorage
export async function loadSettingsFromSupabase(): Promise<AppSettings> {
  try {
    if (isSupabaseConfigured()) {
      const dbSettings = await supabaseClient.getSettings('general')
      if (dbSettings) {
        const merged = { ...DEFAULT_SETTINGS, ...dbSettings }
        localStorage.setItem('criket_general_settings', JSON.stringify(merged))
        return merged
      }
    }
  } catch (error) {
    console.error('Error loading settings from Supabase:', error)
  }
  return getSettings()
}

export function saveSettings(settings: AppSettings): void {
  localStorage.setItem('criket_general_settings', JSON.stringify(settings))
  // Also save to Supabase if configured
  if (isSupabaseConfigured()) {
    supabaseClient.saveSettings('general', settings).catch((error) => {
      console.error('Error saving settings to Supabase:', error)
    })
  }
}
